import * as React from 'react';

function SvgResponse(props) {
  return (
    <svg width={20} height={20} viewBox="0 0 20 20" fill="none" {...props}>
      <path
        xmlns="http://www.w3.org/2000/svg"
        d="M11.63 6.126c0 .1-.074.185-.173.2-2.953.443-5.32 1.681-7.103 3.714-1.337 1.535-2.289 3.427-2.856 5.674-.052.21.228.337.365.17 1.043-1.271 2.271-2.232 3.685-2.882 1.634-.752 3.595-1.138 5.882-1.16.11 0 .2.09.2.2v3.146a.2.2 0 00.341.142l6.072-6.072a.2.2 0 000-.283l-6.072-6.072a.2.2 0 00-.341.141v3.082z"
        fill={props.color}
      />
    </svg>
  );
}

export default SvgResponse;
